<template>
  <main>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="mb-5" style="overflow: hidden">
          <transition name="slide-banner" mode="out-in">
            <b-img :key="getBanner" :src="getBanner" fluid></b-img>
          </transition>
        </b-col>
        <b-col class="pl-0" lg="3">
          <Aside :productCategory="getProductCategory" />
        </b-col>

        <b-col lg="9" v-if="!isRefill">
          <b-row>
            <b-col lg="7">
              <Show :images="getImages" />
            </b-col>
            <b-col lg="5" class="pr-0">
              <MainFeatures :mainFeatures="getMianFeatures" />
            </b-col>
          </b-row>
          <OtherFeatures
            v-if="getOtherFeature.length !== 0"
            :otherFeature="getOtherFeature"
          />
          <Specification :specification="getSpecification" />
          <Adapter :adapters="getAdapters" v-if="getAdapters.length > 0" />
        </b-col>
        <b-col lg="9" v-else>
          <Refill />
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import Aside from "./_aside";
import Show from "./_show";
import MainFeatures from "./_mainfeatures";
import OtherFeatures from "./_otherfeatures";
import Specification from "./_specification";
import Adapter from "./_adapter";
import { productItems, productCategory, adapter } from "@/data";
import Refill from "@/views/Refill";

export default {
  components: {
    Aside,
    Show,
    MainFeatures,
    OtherFeatures,
    Specification,
    Adapter,
    Refill,
  },
  computed: {
    getProductCategory() {
      return productCategory;
    },
    getBanner() {
      return this.isRefill ? "" : productItems[this.$route.params.name].banner;
    },
    getImages() {
      return this.isRefill ? [] : productItems[this.$route.params.name].images;
    },
    getMianFeatures() {
      let { mainFeatures, featureIcons, material } =
        productItems[this.$route.params.name];
      return this.isRefill
        ? {}
        : { desc: mainFeatures, featureIcons, material };
    },
    getOtherFeature() {
      return this.isRefill
        ? []
        : productItems[this.$route.params.name].otherFeatures;
    },
    getSpecification() {
      return this.isRefill
        ? []
        : productItems[this.$route.params.name].specification;
    },
    getAdapters() {
      return this.isRefill
        ? []
        : productItems[this.$route.params.name].adapters.map((v) => ({
            name: v,
            ...adapter[v],
          }));
    },
    isRefill() {
      return this.$route.params.name == "refill";
    },
  },
};
</script>

<style lang="scss">
.product-section {
  margin-bottom: 70px;
  &-title {
    margin-bottom: 15px;
    color: $color-main;
    font: {
      size: 24px !important;
      weight: bold;
    }
  }
}

.slide-banner-enter-active {
  transition: all 0.3s ease;
}
.slide-banner-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-banner-enter,
.slide-banner-leave-to {
  opacity: 0;
}
</style>